import CASL from '@/utils/constants/casl'

export default {
  path: 'app-banner',
  children: [
    {
      path: '',
      name: 'app-banner.list',
      meta: {
        action: 'read',
        subject: CASL.ACCESS.MOBILE_APP_SETUP
      },
      component: () => import('./list/AppBannerListPage.vue')
    }
  ]
}
